module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    on: {
      "click": function($event) {
        return _vm.showCoverAction(false)
      }
    }
  }, [_c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.popup.show),
      callback: function($$v) {
        _vm.$set(_vm.popup, "show", $$v)
      },
      expression: "popup.show"
    }
  }, [(_vm.popup.type == 1) ? _c('div', {
    staticClass: "guideCover currencyBox"
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.4533rem"
    }
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('ul', _vm._l((_vm.guideList), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2.93rem",
      "display": "block",
      "margin": "auto"
    },
    attrs: {
      "src": "//cdn.yxvzb.com/img/Group118.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.2666rem"
    }
  }, [_vm._v("公众号：医学V视界")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 2) ? _c('div', {
    staticClass: "currencyBox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-bottom": "0.4533rem"
    }
  }, [_vm._v("\n          重要提示\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.3733rem",
      "text-align": "left"
    }
  }, [_vm._v("\n          提现将由“医学V视界”公众号以微信红包的形式发送。提现时请确保关注此公众号中。\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.3733rem",
      "text-align": "left"
    }
  }, [_vm._v("\n          由于未关注公众号而导致提现失败，相关责任及损失将由您个人承担。\n        ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2.93rem",
      "display": "block",
      "margin": "auto",
      "margin-top": "0.48rem"
    },
    attrs: {
      "src": "//cdn.yxvzb.com/img/Group118.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.2666rem",
      "margin-top": "0.133rem"
    }
  }, [_vm._v("\n          公众号：医学V视界\n        ")]), _vm._v(" "), _c('x-button', {
    staticClass: "bt1",
    nativeOn: {
      "click": function($event) {
        return _vm.showCoverAction(false)
      }
    }
  }, [_vm._v("我知道了")])], 1) : _vm._e(), _vm._v(" "), (_vm.popup.type == 3) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E6%8F%90%E7%8E%B0%E6%88%90%E5%8A%9F@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.72rem"
    }
  }, [_vm._v("\n          提现成功，请查收红包\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          如未收到，请在公众号留言与客服联系\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 4) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%AE%8C%E5%96%84%E4%BF%A1%E6%81%AF@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n          提现用户需完善信息\n        ")]), _vm._v(" "), _c('x-button', {
    staticClass: "bt1",
    staticStyle: {
      "margin-top": "0.64rem"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.jump.apply(null, arguments)
      }
    }
  }, [_vm._v("前往完善")])], 1) : _vm._e(), _vm._v(" "), (_vm.popup.type == 5) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "0.9866rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%AE%8C%E5%96%84%E4%BF%A1%E6%81%AF@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.72rem"
    }
  }, [_vm._v("\n          每天最多领取3个好友红包\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          把机会留给别人吧\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 6) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "1.24rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E6%9C%AA%E6%8A%A2%E5%88%B0%E7%BA%A2%E5%8C%85-%E5%BC%B9%E5%B1%82@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n          差一点就抢到红包了\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          下次一定要眼疾手快哦\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.popup.type == 7) ? _c('div', {
    staticClass: "currencyBox"
  }, [_c('img', {
    staticStyle: {
      "width": "5.6rem",
      "margin-top": "0.2133rem"
    },
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%BE%97%E7%BA%A2%E5%8C%85-%E5%BC%B9%E5%B1%82@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.4533rem",
      "font-weight": "bold",
      "margin-top": "0.8rem"
    }
  }, [_vm._v("\n          恭喜，获得红包"), _c('span', {
    staticStyle: {
      "color": "#e22b1b",
      "margin-left": "0.21rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.money) + "元")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#666",
      "margin-top": "0.32rem"
    }
  }, [_vm._v("\n          累计满1元后，记得关注“医学V视界”提现\n        ")])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7d0373c6"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/guideCover.vue
// module id = 241
// module chunks = 1